var FeaturedEvents_timeout = false;
var FeaturedEvents_rtime;
var FeaturedEvents_delta = 200;

var FeaturedEvents = {
    init:function(){
        featuredEventequalizeHeight();
        $(window).resize(function(){
          var FeaturedEvents_timeout = new Date();
          if (FeaturedEvents_timeout === false) {
            FeaturedEvents_timeout = true;
            featuredEventResizeDeltaFunction();
          }
        });
        $('.event-featured-item .show-map').click(function(){
              $(this).closest('.details').toggleClass('show_map');
			if( $(this).children('.hide_label').hasClass('hidden')){
				$(this).children('.hide_label').removeClass('hidden');
			}else{
				$(this).children('.hide_label').addClass('hidden');
			}
			if( $(this).children('.show_label').hasClass('hidden')){
				$(this).children('.show_label').removeClass('hidden');
			}else{
				$(this).children('.show_label').addClass('hidden');
			}
              return false;
        });
    }
};


function CustomMarker(opts) {
    this.setValues(opts);
}

var EventDetails = {
    init:function(){
        var target = $('.map .map_container');
        var lat = target.data('lat');
        var lng = target.data('lng');
		var country = target.data('country');
		
	
		CustomMarker.prototype = new google.maps.OverlayView();
			CustomMarker.prototype.draw = function() {
				var self = this;
				var div = this.div;
				if (!div) {
					div = this.div = $('' +
						'<div class="marker-pin">'+
						'<div class="shadow"></div>' +
						'<div class="circle"></div>' +
						'<div class="pin-wrap">' +
						'<div class="pin"></div>' +
						'<div class="pin-label">'+country+'</div>' +
						'</div>' +
						'</div>' +
						'')[0];
					this.pinWrap = this.div.getElementsByClassName('pin-wrap');
					this.pin = this.div.getElementsByClassName('pin');
					this.pinShadow = this.div.getElementsByClassName('shadow');
					div.style.position = 'absolute';
					div.style.cursor = 'pointer';
					var panes = this.getPanes();
					panes.overlayImage.appendChild(div);
					google.maps.event.addDomListener(div, "click", function(event) {
						google.maps.event.trigger(self, "click", event);
					});
				}
				var point = this.getProjection().fromLatLngToDivPixel(this.position);
				if (point) {
					div.style.left = point.x + 'px';
					div.style.top = point.y + 'px';
				}
			};
		
		
        initMap(target.get(0),lat,lng);
        $('.event-header .show-map').click(function(){
              $('.event-header').toggleClass('show_map');
              return false;
        });
    }
};


function featuredEventResizeDeltaFunction(){
  if (new Date() - FeaturedEvents_rtime < FeaturedEvents_delta) {
      setTimeout(featuredEventResizeDeltaFunction, FeaturedEvents_delta);
  } else {
      FeaturedEvents_timeout = false;
     featuredEventequalizeHeight();
  }
}

function EventGridItemMap(){

		$('.event-grid-item .map .map_container').each(function(){
		  	var $this = $(this);
		    var target = $this.get(0);
		    var lat = $this.data('lat');
		    var lng = $this.data('lng');
			var country =  $this.data('country');
			
			CustomMarker.prototype = new google.maps.OverlayView();
			CustomMarker.prototype.draw = function() {
				var self = this;
				var div = this.div;
				if (!div) {
					div = this.div = $('' +
						'<div class="marker-pin">'+
						'<div class="shadow"></div>' +
						'<div class="circle"></div>' +
						'<div class="pin-wrap">' +
						'<div class="pin"></div>' +
					   '<div class="pin-label">'+country+'</div>' +
						'</div>' +
						'</div>' +
						'')[0];
					this.pinWrap = this.div.getElementsByClassName('pin-wrap');
					this.pin = this.div.getElementsByClassName('pin');
					this.pinShadow = this.div.getElementsByClassName('shadow');
					div.style.position = 'absolute';
					div.style.cursor = 'pointer';
					var panes = this.getPanes();
					panes.overlayImage.appendChild(div);
					google.maps.event.addDomListener(div, "click", function(event) {
						google.maps.event.trigger(self, "click", event);
					});
				}
				var point = this.getProjection().fromLatLngToDivPixel(this.position);
				if (point) {
					div.style.left = point.x + 'px';
					div.style.top = point.y + 'px';
				}
			};
		    initMap(target,lat,lng);
		});
		$('.event-grid-item .show-map').click(function(){
			  $(this).closest('.event-grid-item').toggleClass('show_map');
				if( $(this).children('.hide_label').hasClass('hidden')){
						$(this).children('.hide_label').removeClass('hidden');
				}else{
						$(this).children('.hide_label').addClass('hidden');
				}
				if( $(this).children('.show_label').hasClass('hidden')){
						$(this).children('.show_label').removeClass('hidden');
				}else{
						$(this).children('.show_label').addClass('hidden');
				}
				return false;
		});
}


function featuredEventequalizeHeight(){
    $('.event-featured-item .map').each(function(){
        //$(this).find('.map_container').css({'height':$(this).prev().innerHeight()});
    });
     $('.event-featured-item .map .map_container').each(function(){
        var $this = $(this);
        var target = $this.get(0);
        var lat = $this.data('lat');
        var lng = $this.data('lng');
		var country =  $this.data('country');
		 
		 CustomMarker.prototype = new google.maps.OverlayView();
			CustomMarker.prototype.draw = function() {
				var self = this;
				var div = this.div;
				if (!div) {
					div = this.div = $('' +
						'<div class="marker-pin">' +
						'<div class="shadow"></div>' +
						'<div class="circle"></div>' +
						'<div class="pin-wrap">' +
						'<div class="pin"></div>' +
						'<div class="pin-label">'+country+'</div>' +
						'</div>' +
						'</div>' +
						'')[0];
					this.pinWrap = this.div.getElementsByClassName('pin-wrap');
					this.pin = this.div.getElementsByClassName('pin');
					this.pinShadow = this.div.getElementsByClassName('shadow');
					div.style.position = 'absolute';
					div.style.cursor = 'pointer';
					var panes = this.getPanes();
					panes.overlayImage.appendChild(div);
					google.maps.event.addDomListener(div, "click", function(event) {
						google.maps.event.trigger(self, "click", event);
					});
				}
				var point = this.getProjection().fromLatLngToDivPixel(this.position);
				if (point) {
					div.style.left = point.x + 'px';
					div.style.top = point.y + 'px';
				}
			};
		 
		 
        initMap(target,lat,lng);
    });
}

function initMap(target,lat,lng) {
		if (typeof target !== "undefined") {
			
				var map_styling = [
					  {
						"elementType": "labels",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "administrative",
						"elementType": "geometry",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "administrative.land_parcel",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "administrative.neighborhood",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "landscape",
						"stylers": [
						  {
							"color": "#eaeaea"
						  }
						]
					  },
					  {
						"featureType": "poi",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "poi.attraction",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "poi.business",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "poi.government",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "poi.medical",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "poi.park",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "poi.place_of_worship",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "road",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "road",
						"elementType": "labels.icon",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "transit",
						"stylers": [
						  {
							"visibility": "off"
						  }
						]
					  },
					  {
						"featureType": "water",
						"stylers": [
						  {
							"color": "#212121"
						  }
						]
					  }
					];
				var uluru = {lat: lat, lng: lng};
				var map = new google.maps.Map(target, {
					zoom: 4,
					//styles:map_styling,
					disableDefaultUI: true,
					center: uluru
				});
			 	
			
				var latLng = new google.maps.LatLng( lat , lng);
			
				var marker = new CustomMarker({
					position: latLng,
					map: map
				});
		}
}
